import { Flex, Radios, Text } from "src/elements";
import { OTouchedTitle } from "./OTouched";

interface Props<T> {
  title: string;
  options: Array<{ label: string; value: T; isDisabled?: boolean }>;
  value: T;
  setValue: (value: T) => void;
  isDisabled?: boolean;
  direction?: "column";

  path?: string;
}

export const RuleRadios = <T,>({
  title,
  options,
  value,
  setValue,
  isDisabled,
  direction,
  path,
}: Props<T>) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px">
      <OTouchedTitle path={path}>
        <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
          {title}
        </Text>
      </OTouchedTitle>

      <Radios
        width="auto"
        options={options}
        value={value}
        setValue={setValue}
        isDisabled={isDisabled}
        direction={direction}
      />
    </Flex>
  );
};
